import React, { useState, useMemo } from 'react';
import { useQuery } from 'react-query';
import usePersonalInfo from 'src/Views/PersonalInfo/usePersonalInfo';
import { useDragAndDrop } from 'src/hooks/useDragAndDrop';
import SearchableSelect from 'src/Components/Common/SearchableSelect/SearchableSelect';
import { adminUsersService, sortAssignableUsersByLastName, } from 'src/Utils/adminUsersService';
import { InputSection, Label } from '../sharedModalStyles';
import { ModalLayout, DocumentsSectionComponent } from '../sharedModalComponents';
var AuthorizePaymentModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, ticket = _a.ticket, budgetRequests = _a.budgetRequests, onConfirm = _a.onConfirm, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b;
    var userProfile = usePersonalInfo().data;
    var _c = useDragAndDrop(), files = _c.files, addFiles = _c.addFiles, clearFiles = _c.clearFiles, removeFile = _c.removeFile;
    var _d = useState(null), authorizedById = _d[0], setAuthorizedById = _d[1];
    var _e = useState(null), budgetRequestId = _e[0], setBudgetRequestId = _e[1];
    var _f = useQuery('assignableUsers', adminUsersService.getAssignableUsers).data, assignableUsers = _f === void 0 ? [] : _f;
    var sortedAssignableUsers = useMemo(function () { return sortAssignableUsersByLastName(assignableUsers); }, [assignableUsers]);
    var assignableUserOptions = useMemo(function () {
        return sortedAssignableUsers.map(function (user) { return ({
            value: user.id,
            label: user.first_name + " " + user.last_name,
        }); });
    }, [sortedAssignableUsers]);
    var budgetRequestOptions = useMemo(function () {
        return budgetRequests.map(function (request) {
            var _a;
            var providerName = ((_a = request.provider) === null || _a === void 0 ? void 0 : _a.name) || 'Proveedor sin nombre';
            var rawComment = (request.internal_comment || '').trim();
            if (!rawComment) {
                return {
                    value: request.id,
                    label: providerName,
                };
            }
            var MAX_COMMENT_LENGTH = 60;
            var truncatedComment = rawComment.length > MAX_COMMENT_LENGTH
                ? rawComment.slice(0, MAX_COMMENT_LENGTH - 3) + "..."
                : rawComment;
            return {
                value: request.id,
                label: providerName + " - " + truncatedComment,
            };
        });
    }, [budgetRequests]);
    var latestBudgetRequestId = useMemo(function () {
        if (budgetRequests.length === 0) {
            return null;
        }
        var latestBudgetRequest = budgetRequests.reduce(function (latest, current) {
            if (!latest)
                return current;
            return new Date(current.created_at) > new Date(latest.created_at)
                ? current
                : latest;
        }, budgetRequests[0]);
        return latestBudgetRequest.id;
    }, [budgetRequests]);
    React.useEffect(function () {
        if (userProfile && !authorizedById && assignableUsers.length > 0) {
            var currentUser = assignableUsers.find(function (user) {
                return (user.first_name === userProfile.first_name || user.first_name === userProfile.name) &&
                    (user.last_name === userProfile.last_name || user.last_name === userProfile.surname);
            });
            if (currentUser) {
                setAuthorizedById(currentUser.id);
            }
        }
    }, [userProfile, authorizedById, assignableUsers]);
    React.useEffect(function () {
        if (!isOpen) {
            clearFiles();
            setAuthorizedById(null);
            setBudgetRequestId(null);
            return;
        }
        if (!budgetRequestId && latestBudgetRequestId) {
            setBudgetRequestId(latestBudgetRequestId);
        }
    }, [isOpen, clearFiles, budgetRequestId, latestBudgetRequestId]);
    var handleFilesSelected = function (newFiles) {
        addFiles(newFiles);
    };
    var handleConfirm = function () {
        if (authorizedById && budgetRequestId) {
            onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(authorizedById, budgetRequestId, files);
        }
    };
    var handleClose = function () {
        clearFiles();
        setAuthorizedById(null);
        onClose();
    };
    return (React.createElement(ModalLayout, { isOpen: isOpen, onClose: handleClose, title: "Autorizar pago", ticket: ticket, confirmButtonLabel: "Confirmar Autorizaci\u00F3n", onConfirm: handleConfirm, isConfirmDisabled: !authorizedById || !budgetRequestId, isLoading: isLoading },
        React.createElement(InputSection, null,
            React.createElement(Label, null,
                "Autorizaci\u00F3n a cargo de",
                React.createElement("span", null, " (obligatorio)")),
            React.createElement(SearchableSelect, { value: authorizedById, onChange: function (value) {
                    return setAuthorizedById(value ? value : null);
                }, options: assignableUserOptions, placeholder: "Selecciona un administrador" })),
        React.createElement(InputSection, null,
            React.createElement(Label, null,
                "Solicitud de presupuesto",
                React.createElement("span", null, " (obligatorio)")),
            React.createElement(SearchableSelect, { value: budgetRequestId, onChange: function (value) {
                    return setBudgetRequestId(value ? value : null);
                }, options: budgetRequestOptions, placeholder: "Selecciona una solicitud de presupuesto" })),
        React.createElement(DocumentsSectionComponent, { files: files, onFilesSelected: handleFilesSelected, onRemoveFile: removeFile })));
};
export default AuthorizePaymentModal;
